import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin } from 'react-icons/fa';

const teamMembers = [
  {
    name: 'Prof. Rama Rao Bokka',
    title: 'Founder & President',
    intro: 'WTO Chair (Rwanda), CILT Fellow, and World Bank consultant. Over 40 years in logistics education, policy, and curriculum design.',
    linkedin: 'https://www.linkedin.com/in/rama-rao-b-095177215'
  },
  {
    name: 'Dr. Venkat Bokka',
    title: 'Founder & Chief Executive Officer',
    intro: 'PhD from IIT Delhi, Senior Member IEEE (Robotics & Automation). Expert in AI and embedded systems. National leader in tech-education innovation. Life Member, Instrument Society of India.',
    linkedin: 'https://www.linkedin.com/in/venkatb7'
  },
  {
    name: 'Ms. Sree Sailaja Sowmya Katta',
    title: 'Chief Technology Officer',
    intro: 'M.Tech in Embedded Systems & VLSI. Former researcher at IIT Delhi. Expert in scalable learning systems, automation, and digital architecture.',
    linkedin: 'https://www.linkedin.com/in/sreessk'
  },
  {
    name: 'Ms. Bokka Pavani',
    title: 'Chief Operating Officer',
    intro: 'PhD researcher in AI & Robotics. Specialist in sustainable systems, interdisciplinary product integration, and prototyping.',
    linkedin: 'https://www.linkedin.com/in/pavani-b-2549a4214'
  }
];

const Team = () => {
  return (
    <section
      id="team"
      style={{
        padding: '60px 20px',
        background: '#f0f8ff',
        fontFamily: 'Roboto',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'auto'
      }}
    >
      <div style={{ minWidth: '320px', maxWidth: '1500px', margin: '0 auto' }}>
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '50px', textAlign: 'center' }}
        >
          <div
            style={{
              display: 'inline-block',
              background: '#007bff',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '24px',
              padding: '10px 25px',
              borderRadius: '25px',
              textTransform: 'uppercase',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
          >
            Our Team
          </div>
          <h2
            style={{
              color: 'Blue',
              fontSize: '22px',
              marginTop: '15px',
              fontWeight: 'bold'
            }}
          >
            Meet Our Leadership
          </h2>
          <p style={{ color: 'black', fontSize: '22px', marginTop: '8px' }}>
            Driving innovation and excellence at Sevenky
          </p>
        </motion.div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            gap: '20px',
            overflowX: 'auto',
            paddingBottom: '20px'
          }}
        >
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -10 }}
              transition={{ duration: 0.5 }}
              style={{
                minWidth: '250px',
                maxWidth: '360px',
                height: 'auto',
                background: 'white',
                borderRadius: '15px',
                boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
                padding: '15px',
                textAlign: 'left',
                boxSizing: 'border-box',
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <h3 style={{ fontFamily: 'Arial', fontSize: '22px', fontWeight: 'bold', marginBottom: '8px', color: '#00008B' }}>
                  {member.name}
                </h3>
                <p style={{ fontStyle: 'italic', marginBottom: '10px', fontSize: '18px' }}>{member.title}</p>
                <p style={{ fontSize: '18px', color: '#222' }}>
                  {member.intro}
                </p>
              </div>
              <div style={{ textAlign: 'center', marginTop: '10px' }}>
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" style={{ color: '#00008B' }}>
                  <FaLinkedin style={{ fontSize: '22px' }} />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
